let hasSeen = false;
import { get, put } from '../../services/objectStoreService.js';

const key = 'safePayment.onboardingSeen';
const ninetyDaysInSeconds = 60 * 60 * 24 * 60;

export function hasSeenOnboarding() {
    let value;
    try {
        value = get(key);
    } catch (e) {
        return hasSeen;
    }

    if (value === null) {
        return hasSeen;
    }

    if (hasSeen) {
        return true;
    }

    return !!value;
}

export function setSeenOnboarding() {
    if (hasSeenOnboarding()) {
        return;
    }

    hasSeen = true;

    try {
        put(key, 'true', ninetyDaysInSeconds);
    } catch (e) {
        // it's ok
    }
}



// WEBPACK FOOTER //
// ./safeTrade/onboarding/onboardingService.js